const { vec4 } = require('glov/common/vmath.js');
const { spritesheetRegister } = require('glov/client/spritesheet.js');
module.exports = {
  name: 'ruins',
  tiles: {
    ceiling1: 0,
    ceiling2: 1,
    ceiling3: 2,
    detail: 3,
    door_locked: 4,
    door_unlocked: 5,
    door1: 6,
    door2: 7,
    door3: 8,
    floor1a: 9,
    floor1b: 10,
    floor2: 11,
    floor3: 12,
    secret1: 13,
    wall1: 14,
    wall1b: 15,
    wall2: 16,
    wall3: 17
  },
  uidata: {
    rects: [
      vec4(8/1024,8/64,40/1024,40/64),
      vec4(56/1024,8/64,88/1024,40/64),
      vec4(104/1024,8/64,136/1024,40/64),
      vec4(152/1024,8/64,184/1024,40/64),
      vec4(200/1024,8/64,232/1024,40/64),
      vec4(248/1024,8/64,280/1024,40/64),
      vec4(296/1024,8/64,328/1024,40/64),
      vec4(344/1024,8/64,376/1024,40/64),
      vec4(392/1024,8/64,424/1024,40/64),
      vec4(440/1024,8/64,472/1024,40/64),
      vec4(488/1024,8/64,520/1024,40/64),
      vec4(536/1024,8/64,568/1024,40/64),
      vec4(584/1024,8/64,616/1024,40/64),
      vec4(632/1024,8/64,664/1024,40/64),
      vec4(680/1024,8/64,712/1024,40/64),
      vec4(728/1024,8/64,760/1024,40/64),
      vec4(776/1024,8/64,808/1024,40/64),
      vec4(824/1024,8/64,856/1024,40/64)
    ]
  },
  FRAME_CEILING1: 0,
  FRAME_CEILING2: 1,
  FRAME_CEILING3: 2,
  FRAME_DETAIL: 3,
  FRAME_DOOR_LOCKED: 4,
  FRAME_DOOR_UNLOCKED: 5,
  FRAME_DOOR1: 6,
  FRAME_DOOR2: 7,
  FRAME_DOOR3: 8,
  FRAME_FLOOR1A: 9,
  FRAME_FLOOR1B: 10,
  FRAME_FLOOR2: 11,
  FRAME_FLOOR3: 12,
  FRAME_SECRET1: 13,
  FRAME_WALL1: 14,
  FRAME_WALL1B: 15,
  FRAME_WALL2: 16,
  FRAME_WALL3: 17
};
spritesheetRegister(module.exports);
